"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "18", height: "18", viewBox: "0 0 18 18", className: "Icon milanote-logo-small", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#F4511C" },
            _react2.default.createElement("path", { d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zm0 1A9 9 0 1 1 9 0a9 9 0 0 1 0 18z" }),
            _react2.default.createElement("path", { d: "M12.854 12.146l-7-7A.5.5 0 0 0 5 5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.854-.354l-7 7a.5.5 0 0 0 .708.708l7-7L12 5.5v7l.5-.5h-7l.5.5v-7l-.854.354 7 7a.5.5 0 0 0 .708-.708z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/milanote-logo-small.js
// module id = 1814
// module chunks = 0